module.exports = __webpack_public_path__ + "img/Bruiser.02dea04d.png";